/**
 * The <option>s of a bunkers trader box: who it offers (ledger row 134) and how
 * each person is named (row 133). Every trader box on the bunkers enquiry and
 * recaps draws its people here, so no box can offer or name anyone its own way.
 */
import React from 'react';

import { traderLabel } from '../../utils/traderLabel';
import { bunkersTraderOptions } from '../../utils/traderList';

const TraderOptions = ({ traders, box, saved }) => bunkersTraderOptions(traders, { box, saved })
  .map((t) => <option key={t.id} value={t.id}>{traderLabel(t)}</option>);

export default TraderOptions;
